import { FC } from 'react';
import { MaybeLoanID } from 'src/common/types';
import { ServerSideModuleData } from '../../GetServerSideProps/utils/getServerSideModuleData';
import { Upsell } from './Upsell';
import { useUpsellState } from './hooks/useUpsellState';
export type WiredUpsellProps = {
    loanID: MaybeLoanID;
    serverFetchedData: Pick<ServerSideModuleData, 'Upsell'>;
};
export const WiredUpsell: FC<WiredUpsellProps> = ({ loanID, serverFetchedData }) => {
    const {
        isLoading,
        onPrimaryCTAClick,
        onSecondaryCTAClick,
        variant,
        trackSecondaryCTAClick,
        trackPrimaryCTAClick,
        valuation,
        purchasePrice,
        address,
        documentURL,
        downloadURL,
    } = useUpsellState({ loanID, serverFetchedData });

    return (
        <Upsell
            loanID={loanID}
            isLoading={isLoading}
            trackSecondaryCTAClick={trackSecondaryCTAClick}
            trackPrimaryCTAClick={trackPrimaryCTAClick}
            valuation={valuation}
            address={address}
            documentURL={documentURL}
            downloadURL={downloadURL}
            purchasePrice={purchasePrice}
            variant={variant}
            onPrimaryCTAClick={onPrimaryCTAClick}
            onSecondaryCTAClick={onSecondaryCTAClick}
        />
    );
};
